export function AdaptiveBody({ children }: { children: React.ReactNode }) {
  /*function updateViewportHeight() {
    let height = window.visualViewport?.height ?? window.innerHeight;
    let vh = height * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
  }

  useEffect(() => {
    updateViewportHeight();
    window.visualViewport?.addEventListener('resize', updateViewportHeight);
    return () => {
      window.visualViewport?.removeEventListener('resize', updateViewportHeight);
    }
  }, []);*/

  // `flow-root` establishes a block formatting context so the sidebar shell's
  // top margin (which reserves the impersonation banner's height) cannot
  // collapse out through this wrapper and drag `body` itself down — body keeps
  // a full-viewport height, so a collapsed margin would push the document
  // 36px past the viewport and make the whole page scrollable. No-op outside
  // impersonation, where that margin is 0.
  return <div className="flow-root min-h-dvh h-full">{children}</div>;
}
